<template >
  <div id="animationvisualizer">
    <lottie
      :options="defaultOptions"
      :autoplay="true"
      :loop="true"
      :height="100"
      :width="100"
      class="animationvisualizer"
      v-on:animCreated="handleAnimation"
    />
            <!-- <av-media class="animation5" :canv-width="150" :canv-height="60"
      :frequ-line-cap="true" :frequ-lnum="7"
      :line-width="7" type="frequ" :symmetric="true" :media="media" line-color="limegreen" /> -->
  </div>
</template>

<style scoped>
.animationvisualizer {
  width:100%;
  height:100%;
  display:block;
  overflow: hidden;
  transform: translate3d(0,0,0);
  text-align: center;
  opacity: 0.9;
}
.text-color {
  color: #fff !important;
}
</style>

<script>
// import Lottie from "./lottie.vue";
import Lottie from "vue-lottie";
import * as animationData from "./../assets/mockups/cogorb2.json";

export default {
  name: "AnimationEmail",
  components: {
    lottie: Lottie
  },
  data: () => ({
    defaultOptions: { animationData: animationData.default },
  }),
  methods: {
    handleAnimation: function(anim) {
      this.anim = anim;
    },
  }
};
</script>
